import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WhatsappMetaAppAPI from '../../api/whatsappMetaApps';

// Local mutation types — this module doesn't need to share them with any
// other module, so they aren't added to the central mutation-types.js.
const SET_UI_FLAG = 'whatsappMetaApps/SET_UI_FLAG';
const SET = 'whatsappMetaApps/SET';
const ADD = 'whatsappMetaApps/ADD';
const EDIT = 'whatsappMetaApps/EDIT';
const DELETE = 'whatsappMetaApps/DELETE';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getWhatsappMetaApps(_state) {
    return _state.records;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(SET_UI_FLAG, { isFetching: true });
    try {
      const response = await WhatsappMetaAppAPI.get();
      commit(SET, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(SET_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, appObj) => {
    commit(SET_UI_FLAG, { isCreating: true });
    try {
      const response = await WhatsappMetaAppAPI.create(appObj);
      commit(ADD, response.data);
      return response.data;
    } finally {
      commit(SET_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(SET_UI_FLAG, { isUpdating: true });
    try {
      const response = await WhatsappMetaAppAPI.update(id, updateObj);
      commit(EDIT, response.data);
      return response.data;
    } finally {
      commit(SET_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(SET_UI_FLAG, { isDeleting: true });
    try {
      await WhatsappMetaAppAPI.delete(id);
      commit(DELETE, id);
    } finally {
      commit(SET_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [SET_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [SET]: MutationHelpers.set,
  [ADD]: MutationHelpers.create,
  [EDIT]: MutationHelpers.update,
  [DELETE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
